import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CustomerGrowthChart = () => {
  const [activeTab, setActiveTab] = useState('growth');
  // This would normally come from an API or state management
  const chartData = {
    growth: [{
      month: 'Jan',
      customers: 950
    }, {
      month: 'Feb',
      customers: 987
    }, {
      month: 'Mar',
      customers: 1025
    }, {
      month: 'Apr',
      customers: 1078
    }, {
      month: 'May',
      customers: 1124
    }, {
      month: 'Jun',
      customers: 1156
    }, {
      month: 'Jul',
      customers: 1198
    }, {
      month: 'Aug',
      customers: 1260
    }, {
      month: 'Sep',
      customers: 1284
    }]
  };
  // Calculate the maximum value for scaling
  const maxValue = Math.max(...chartData.growth.map(item => item.customers));
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-2 sm:mb-0">
          Customer Growth
        </h2>
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-md">
          <button className={`px-3 py-1 text-sm rounded-md ${activeTab === 'growth' ? 'bg-white shadow-sm' : 'text-gray-600'}`} onClick={() => setActiveTab('growth')}>
            Growth
          </button>
          <button className={`px-3 py-1 text-sm rounded-md ${activeTab === 'churn' ? 'bg-white shadow-sm' : 'text-gray-600'}`} onClick={() => setActiveTab('churn')}>
            Churn
          </button>
          <button className={`px-3 py-1 text-sm rounded-md ${activeTab === 'net' ? 'bg-white shadow-sm' : 'text-gray-600'}`} onClick={() => setActiveTab('net')}>
            Net Growth
          </button>
        </div>
      </div>
      <div className="h-64 relative">
        <div className="absolute inset-0 flex items-end">
          {chartData.growth.map((item, index) => {
          const height = item.customers / maxValue * 100;
          const isLastMonth = index === chartData.growth.length - 1;
          return <div key={index} className="flex-1 flex flex-col items-center justify-end h-full">
                <div className={`w-full max-w-[30px] rounded-t transition-all cursor-pointer relative group ${isLastMonth ? 'bg-green-500 hover:bg-green-600' : 'bg-blue-500 hover:bg-blue-600'}`} style={{
              height: `${height}%`
            }}>
                  <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    {item.customers} customers
                  </div>
                </div>
                <span className="text-xs text-gray-500 mt-2">{item.month}</span>
              </div>;
        })}
        </div>
      </div>
      <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-100">
        <div>
          <p className="text-sm text-gray-500">Current Customers</p>
          <p className="text-xl font-bold">1,284</p>
        </div>
        <button className="flex items-center text-sm text-blue-600 font-medium hover:text-blue-800">
          View customer details
          <ArrowRightIcon size={16} className="ml-1" />
        </button>
      </div>
    </div>;
};
export default CustomerGrowthChart;